import Inputmask from 'inputmask';

export default function fPhoneFormat(phone: string) {
    const input = document.createElement('input');
    input.value = phone;
    Inputmask({
        mask: '+7 (999) 999-99-99',
    }).mask(input);
    const phoneFormat = input.value;
    input.remove();
    return phoneFormat;
}
